export default {
	PUBLIC: {
		FIELD_CHANGED: 'forman.field_changed',
	},
	FORM: {
		CONNECT: 'connect',
		DISCONNECT: 'disconnect',
		RESIZE: 'resize',
		CHANGE: 'change',
		BUILD: 'build',
		BUILT: 'built',
		SUBMIT: 'submit',
		SUBMITTED: 'submitted',
		ERROR: 'error',
		LOADING: 'loading',
		LOADED: 'loaded',

		ADVANCED_PARAMETERS_CHANGE: 'advancedParametersChange',

		HAS_ADVANCED_PARAMETERS: 'hasAdvancedParameters',

		G_RECAPTCHA_LOADED: 'gRecaptchaLoaded',
	},
	INPUT: {
		MODE_CHANGE: 'modeChange',
		MODE_CHANGED: 'modeChanged',
		NESTED_CHANGED: 'nestedChanged',
		HAS_DYNAMIC_NESTED: 'hasDynamicNested',
		BUILT: 'inputBuilt',
		CONNECTED: 'inputConnected',
	},
	FIELDSET: {
		BUILT: 'built',
	},
	PICKER: {
		CHANGE: 'change',
		CHANGED: 'changed',
		BEFORE_SELECT_OPTION: 'beforeSelect',
		LOAD_DONE: 'loadDone',
		LOAD_ERROR: 'loadError',
	},
	PANEL: {
		OPEN: 'open',
		CLOSE: 'close',
		OPEN_MENU: 'openPanelMenu',
	},
	DATASTORE: {
		BROWSE: 'browse',
	},
	ACCOUNT: {
		EXTEND_CLICK: 'extendClick',
		ACCOUNT_CREATED: 'accountCreated',
		SCENARIO_INPUT_CREATED: 'accountScenarioInputCreated',
		SCENARIO_INPUT_EDITED: 'accountScenarioInputEdited',
		SCENARIO_INPUT_EXTENDED: 'accountScenarioInputExtended',
		EXTEND_PANEL_CREATED: 'extendPanelCreated',
	},
	CODER: {
		// pill inserted to coder
		PILL_INSERTED: 'pillInserted',
	},
	FILTERS: {
		BUILT: 'filtersBuilt',
	},
};
